module.exports = "wbgdrb.applythrunet.co.in\n"